import { render, staticRenderFns } from "./adf-choose-method.vue?vue&type=template&id=4333268f&scoped=true&"
import script from "./adf-choose-method.vue?vue&type=script&lang=js&"
export * from "./adf-choose-method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4333268f",
  null
  
)

export default component.exports